import styled from "styled-components";
import theme from "~/styles/theme";

export const BreadcrumbHolder = styled.div`
  background-color: ${theme.palette.neutral.primary.light};
  padding: 7px 16px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 7px 0;
  }

  .text {
    color: ${theme.palette.neutral.primary.key};
  }

  a {
    text-decoration: none;
  }

  .MuiLink-root {
    p {
      font-family: ${theme.typography.fontFamilyRegular};
      display: inline;
      line-height: 16px;
    }
  }

  .MuiBreadcrumbs-separator {
    color: ${theme.palette.neutral.primary.key};
  }
`;
